export const RELOAD_TIMEOUT = 30;
export function reload() {
    window.location.href = window.location.origin;
}
